<template>
  <div id="app">
    <router-view/>
    <OverlayMessage/>
    <!-- <CookieLaw/> -->
    <SideMenu/>
    <FreeToProUpgradePopup/>
    <PremiumSuccessPopup/>
    <PremiumToFreePopup/>
    <PremiumToProPopup/>
    <ProSuccessPopup/>
    <ProToFreePopup/>
    <ProToPremiumPopup/>
    <SetupStripePopup/>
    <OverlayConfirm
      style="z-index: var(--zindex-popover);"
      v-bind="$confirmModal._props"
      v-on="$confirmModal._handlers"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { screenResize } from '@/mixins';

import OverlayMessage from '@/components/overlays/OverlayMessage.vue';
// cookie banner is used from nuxt app globally
// import CookieLaw from '@/components/CookieLaw.vue';

import { setZohoSalesIq } from '@/utils/zoho-sales-iq';
import { setReferer } from '@/api/auth';
import SideMenu from '@/components/SideMenu.vue';
import FreeToProUpgradePopup from '@/pages/dashboard/upgrade/FreeToProUpgradePopup';
import PremiumSuccessPopup from '@/pages/dashboard/upgrade/PremiumSuccessPopup';
import PremiumToFreePopup from '@/pages/dashboard/upgrade/PremiumToFreePopup';
import PremiumToProPopup from '@/pages/dashboard/upgrade/PremiumToProPopup';
import ProSuccessPopup from '@/pages/dashboard/upgrade/ProSuccessPopup';
import ProToFreePopup from '@/pages/dashboard/upgrade/ProToFreePopup';
import ProToPremiumPopup from '@/pages/dashboard/upgrade/ProToPremiumPopup';
import SetupStripePopup from '@/pages/dashboard/upgrade/SetupStripePopup';
import OverlayConfirm from '@/components/overlays/OverlayConfirm';

export default {
  name: 'App',
  mixins: [screenResize],
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Tryb',
    // all titles will be injected into this template
    titleTemplate: '%s | Tryb',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Micro-influencer food community',
      },
      { vmid: 'keywords', name: 'keywords', content: 'food, community' },
    ],
  },
  data() {
    return {
      popup: true,
      editorMode: false,
    };
  },
  created() {
    setReferer(document.referrer);
  },
  components: {
    ProToPremiumPopup,
    ProToFreePopup,
    ProSuccessPopup,
    PremiumToProPopup,
    PremiumToFreePopup,
    PremiumSuccessPopup,
    FreeToProUpgradePopup,
    SideMenu,
    OverlayMessage,
    // CookieLaw,
    SetupStripePopup,
    OverlayConfirm,
  },
  computed: {
    ...mapGetters({
      isInitialized: 'isInitialized',
      developmentMode: 'developmentMode',
    }),
  },
  methods: {
    // ...mapActions({
    //   storeUtmMarks: 'storeUtmMarks',
    // }),
  },
  mounted() {
    if (!this.developmentMode) {
      setZohoSalesIq();
    }
    const { name, path } = this.$route;

    // migrated into nuxt app
    // this.storeUtmMarks(query);

    // TODO: lets use a constant for paths
    if (path.startsWith('/c/')) {
      // TODO: lets create constants for localstorage keys
      localStorage.setItem('landingCommunityRouteName', name);
    }
  },
};
</script>
